
class PanZoomController
{
    constructor(callback)
    {
        this.callback = callback;

        this.notify = this.notify.bind(this);
        this.getRelativePointerPosition = this.getRelativePointerPosition.bind(this);

        this.state = {
            zoom: 1,
            scrollX: 0,
            scrollY: 0,

            isPanning: false,
            isZooming: false,
            x: 0,
            y: 0,
            d: 0,
        };
    }

    notify()
    {
        if (typeof this.callback === 'function')
        {
            this.callback(this.state.zoom, this.state.scrollX, this.state.scrollY);
        }
    }

    reset()
    {
        this.state.zoom = 1;
        this.state.scrollX = 0;
        this.state.scrollY = 0;
        this.state.x = 0;
        this.state.y = 0;
        this.state.d = 0;
        this.state.isPanning = false;
        this.state.isZooming = false;
    }

    /**
     * Returns the relative position of the pointer in the container
     * where (0|0) is the center of the container.
     * @param {*} e 
     */
    getRelativePointerPosition(e)
    {
        let containerRect = this.ref.getBoundingClientRect();

        let x = e.clientX;
        let y = e.clientY;

        if (e.touches && e.touches.length === 2)
        {
            x = (e.touches[0].clientX + e.touches[1].clientX) / 2;
            y = (e.touches[0].clientY + e.touches[1].clientY) / 2;
        }
        else if (e.touches && e.touches.length === 1)
        {
            x = e.touches[0].clientX;
            y = e.touches[0].clientY;
        }

        x -= ((containerRect.width * 0.5) + containerRect.left);
        y -= ((containerRect.height * 0.5) + containerRect.top);

        return { x, y };
    }

    limitMaximumScroll()
    {
        let containerRect = this.ref.getBoundingClientRect();
        //TODO: It would be better to get the rect of the actual image
        let zoom = this.state.zoom;

        let x = containerRect.width * (zoom - 1) * 0.5;
        let y = containerRect.height * (zoom - 1) * 0.5;

        if (this.state.scrollX < -x) this.state.scrollX = -x;
        if (this.state.scrollX > x) this.state.scrollX = x;
        if (this.state.scrollY < -y) this.state.scrollY = -y;
        if (this.state.scrollY > y) this.state.scrollY = y;
        console.log('getMaximumScrollDimension', {x, y});
    }

    clamp(value, min, max)
    {
        return Math.min(Math.max(value, min), max);
    }

    adjustZoomWhilePreservingPan(zoom, e)
    {
        
        let { x, y } = this.getRelativePointerPosition(e);

        let zoomDelta = zoom / this.state.zoom;

        let distanceFromOrigin = {
            x: x - this.state.scrollX,
            y: y - this.state.scrollY
        };

        let distanceFromOriginAfterZoom = {
            x: distanceFromOrigin.x * zoomDelta,
            y: distanceFromOrigin.y * zoomDelta
        };
        this.state.scrollX -= (distanceFromOriginAfterZoom.x - distanceFromOrigin.x);
        this.state.scrollY -= (distanceFromOriginAfterZoom.y - distanceFromOrigin.y);
        this.state.zoom = zoom;
    }

    onWheel(e)
    {
        e.preventDefault();
        //console.log(e);
        //Zooming
        if (e.ctrlKey || e.metaKey)
        {
            if (e.deltaY !== 0)
            {
                let zoomSpeed = (0.01 * this.state.zoom);
                let zoom = this.state.zoom - e.deltaY * zoomSpeed;
                zoom = Math.min(Math.max(1, zoom), 10);

                this.adjustZoomWhilePreservingPan(zoom, e);

                this.limitMaximumScroll();

                this.notify();
            }
        }
        //Panning
        else
        {
            let panSpeed = 1;
            let scrollX = this.state.scrollX - e.deltaX * panSpeed;
            let scrollY = this.state.scrollY - e.deltaY * panSpeed;
            
            this.state.scrollX = scrollX;
            this.state.scrollY = scrollY;

            this.limitMaximumScroll();

            this.notify();
        }
    }

    onTouchStart(e)
    {
        e.preventDefault();
        if (e.touches && e.touches.length === 1)
        {
            //use position of single finger
            this.state.x = e.touches[0].clientX;
            this.state.y = e.touches[0].clientY;
            this.state.d = 0;
            this.state.isPanning = true;
            //console.log('start panning');
        }
        else if (e.touches && e.touches.length === 2)
        {
            //calculate the center pixel of the two fingers
            this.state.x = (e.touches[0].clientX + e.touches[1].clientX) / 2;
            this.state.y = (e.touches[0].clientY + e.touches[1].clientY) / 2;
            //calculate the distance between the two fingers
            this.state.d = Math.sqrt(Math.pow(e.touches[0].clientX - e.touches[1].clientX, 2) + Math.pow(e.touches[0].clientY - e.touches[1].clientY, 2));
            this.state.isZooming = true;
            //console.log('start zooming');
        }
        else if (e.touches && e.touches.length > 2)
        {
            //ignore more than two fingers
            return this.onTouchCancel(e);
        }
    }

    onTouchMove(e)
    {
        e.preventDefault();
        
        if (this.state.isZooming && e.touches.length === 2)
        {
            //calculate the new center pixel of the two fingers
            let x = (e.touches[0].clientX + e.touches[1].clientX) / 2;
            let y = (e.touches[0].clientY + e.touches[1].clientY) / 2;
            //calculate the new distance between the two fingers
            let d = Math.sqrt(Math.pow(e.touches[0].clientX - e.touches[1].clientX, 2) + Math.pow(e.touches[0].clientY - e.touches[1].clientY, 2));
            //calculate the zoom factor
            let zoom = this.state.zoom * (d / this.state.d);
            zoom = Math.min(Math.max(1, zoom), 10);
            //calculate the new scroll position
            let scrollX = this.state.scrollX + (x - this.state.x);
            let scrollY = this.state.scrollY + (y - this.state.y);
            //update the state
            this.state.x = x;
            this.state.y = y;
            this.state.d = d;
            this.state.scrollX = scrollX;
            this.state.scrollY = scrollY;
            this.adjustZoomWhilePreservingPan(zoom, e);
            this.limitMaximumScroll();
            
            this.notify();
        }
        else if (this.state.isPanning && e.touches.length === 1)
        {
            //calculate the new scroll position
            let scrollX = this.state.scrollX + (e.touches[0].clientX - this.state.x);
            let scrollY = this.state.scrollY + (e.touches[0].clientY - this.state.y);
            //update the state
            this.state.x = e.touches[0].clientX;
            this.state.y = e.touches[0].clientY;
            this.state.scrollX = scrollX;
            this.state.scrollY = scrollY;
            this.limitMaximumScroll();

            this.notify();
        }
    }

    onTouchEnd(e)
    {
        e.preventDefault();
        if (this.state.isZooming && e.touches.length < 2)
        {
            this.state.x = e.touches.length === 1 ? e.touches[0].clientX : 0;
            this.state.y = e.touches.length === 1 ? e.touches[0].clientY : 0;
            this.state.d = 0;
            this.state.isZooming = false;
            //console.log('end zooming');
        }
        if (this.state.isPanning && e.touches.length < 1)
        {
            this.state.x = 0;
            this.state.y = 0;
            this.state.d = 0;
            this.state.isPanning = false;
            //console.log('end panning');
        }
    }

    onTouchCancel(e)
    {
        e.preventDefault();
        this.state.x = 0;
        this.state.y = 0;
        this.state.d = 0;
        this.state.isPanning = false;
        this.state.isZooming = false;
    }

    events = {
        ref: dom => { this.ref = dom; },
        onWheel: this.onWheel.bind(this),
        onTouchStart: this.onTouchStart.bind(this),
        onTouchMove: this.onTouchMove.bind(this),
        onTouchEnd: this.onTouchEnd.bind(this),
        //onMouseMove: this.onMouseMove.bind(this),
    };
}

export { PanZoomController };